var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 5.4a.42.42 0 00-.43-.39h-2.93V4c0-2.2-1.81-4-4.04-4a4.02 4.02 0 00-4.04 4v1.01H3.03c-.22 0-.4.17-.42.39L1.5 19.55a.42.42 0 00.42.45h16.14c.12 0 .23-.05.32-.13.08-.1.12-.2.1-.32L17.4 5.4zM7.23 4c0-1.5 1.24-2.74 2.76-2.74A2.75 2.75 0 0112.76 4v1.01H7.24V4zm6.8 3.75c0 2.2-1.81 4-4.04 4a4.02 4.02 0 01-4.04-4v-.38c0-.35.29-.63.64-.63.35 0 .64.28.64.63v.38c0 1.5 1.24 2.73 2.76 2.73a2.75 2.75 0 002.76-2.73v-.38c0-.35.29-.63.64-.63.35 0 .64.28.64.63v.38z",
    fill: "currentColor"
  })));
}
export default SvgCart;